module.exports = __webpack_public_path__ + "static/line-with-gaps-767a01aea760d4fc421dd27b5a456a47.png";